import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../utils/api";

export interface WebsiteResponse {
  cvr: number;
  urls: VerifiedUrl[];
}

export interface VerifiedUrl {
  url: string;
  verifiedAt: string;
}

const fetchWebsite = async (lassoId?: string): Promise<WebsiteResponse> => {
  console.debug("fetchWebsite", lassoId);
  if (!lassoId) return Promise.reject("No lassoId provided");
  const response = await api.get(`data/websites/${lassoId}`);
  if (!response.ok) {
    throw new Error(
      `Failed to fetch website: ${response.status} ${response.statusText}`,
    );
  }
  return response.json<WebsiteResponse>();
};

export const getWebsiteQueryOptions = (lassoId?: string) =>
  queryOptions({
    queryKey: ["website", lassoId],
    queryFn: () => fetchWebsite(lassoId),
    enabled: !!lassoId,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

export const useWebsiteQuery = (lassoId?: string) => {
  return useQuery(getWebsiteQueryOptions(lassoId));
};
